import moment from "moment-timezone";

export default (currentDate, unit = "day") => {
  if (!currentDate) return false;
  return currentDate.isSameOrAfter(moment(), unit);
};
